const CollegeData = [
    {
      id: 1,
      college_name: "Gokul Institute of Technology & Sciences, Bobili",
      college_code: "H9",
      District: "Vizianagaram",
      Type: "Affiliated",
      Postal_Address: "Piridi Village, Bobili, Vizianagaram, Andhra Pradesh",
      Pincode: "535568",
      Status: "active",
    },
    {
      id: 2,
      college_name: "Gokul Institute of Technology & Sciences, Bobili",
      college_code: "H9",
      District: "Vizianagaram",
      Type: "Affiliated",
      Postal_Address: "Piridi Village, Bobili, Vizianagaram, Andhra Pradesh",
      Pincode: "535568",
      Status: "active",
    },
    {
      id: 3,
      college_name: "Gokul Institute of Technology & Sciences, Bobili",
      college_code: "H9",
      District: "Vizianagaram",
      Type: "Affiliated",
      Postal_Address: "Piridi Village, Bobili, Vizianagaram, Andhra Pradesh",
      Pincode: "535568",
      Status: "active",
    },
    {
      id: 4,
      college_name: "Gokul Institute of Technology & Sciences, Bobili",
      college_code: "H9",
      District: "Vizianagaram",
      Type: "Affiliated",
      Postal_Address: "Piridi Village, Bobili, Vizianagaram, Andhra Pradesh",
      Pincode: "535568",
      Status: "active",
    },
  ];

  export default CollegeData;